import { useEffect } from 'react';

const ExternalRedirect = ({ url }: { url: string }) => {
	useEffect(() => {
		globalThis.location.replace(url);
	}, [url]);

	return null;
};

export default ExternalRedirect;
